export enum ORDER_STATUSES {
  ONGOING = 1,
  CLOSED,
  CANCELLED,
  UNRESOLVED,
  DRAFT,
  UNAPPROVED,
}
